import { createSlice } from '@reduxjs/toolkit';
import {
  PENDING,
  RUNNING,
  DONE,
  UNKNOWN_LEVEL,
  SUCCESS_LEVEL,
  WARNING_LEVEL,
  ERROR_LEVEL,
  CONNECTIVITY_CHECK,
  INFORMATION_LEVEL,
} from 'UTILS/constants';

export const initialState = {
  stage: PENDING,
  level: UNKNOWN_LEVEL,
  resultList: [],
  resultDetails: {},
};

const connectivitySlice = createSlice({
  name: CONNECTIVITY_CHECK,
  initialState,
  reducers: {
    start(state) {
      state.progress = 0;
      state.resultList = [];
      state.level = UNKNOWN_LEVEL;
      state.stage = RUNNING;
    },
    success(state, { payload }) {
      state.resultList.push({ level: SUCCESS_LEVEL, ...payload });
      state.level = Math.max(state.level, SUCCESS_LEVEL);
    },
    info(state, { payload }) {
      state.resultList.push({ level: INFORMATION_LEVEL, ...payload });
      state.level = Math.max(state.level, INFORMATION_LEVEL);
    },
    warning(state, { payload }) {
      state.resultList.push({ level: WARNING_LEVEL, ...payload });
      state.level = Math.max(state.level, WARNING_LEVEL);
    },
    error(state, { payload }) {
      state.resultList.push({ level: ERROR_LEVEL, ...payload });
      state.level = ERROR_LEVEL;
    },
    progress(state, { payload }) {
      state.progress = payload.value;
    },
    end(state, { payload }) {
      state.stage = DONE;
      state.resultDetails = payload;
    },
  },
});

export const { start, success, info, warning, error, progress, end } = connectivitySlice.actions;
export default connectivitySlice.reducer;
